import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

/**
 * Terminal group-row renderer for the Session P&L history left grid (clone of the ETS
 * SessionHistoryAggregatedRowHeaderRenderer): renders the terminal name (the group key) in yellow.
 */
@Component({
   selector: 'collars-session-group-row',
   template: `
    <div class="block">
      <span class="group-title">{{title}}</span>
    </div>
  `,
   styles: [
      `
      .block { display: inline-block; width: 100%; text-align: left; }
      .group-title { color: yellow; }
    `
   ]
})
export class CollarsSessionHistoryGroupRowRenderer implements ICellRendererAngularComp {

   public title: any;

   public agInit(params: any): void {
      const node = params.node;
      if (node) {
         // Group key stays the (unique) terminal; the header DISPLAYS the seat's current user, read from a
         // representative leaf row. Falls back to the key when a leaf has no user.
         const leaf = node.allLeafChildren && node.allLeafChildren[0];
         this.title = (leaf && leaf.data && leaf.data.userName) || node.key;
      }
   }

   public refresh(): boolean {
      return false;
   }
}
